// Cleanup of retired non-credential hints. No automatic login recovery remains.
const SESSION_HINT = "fc.auth.session-present";
const RECOVERY_ATTEMPT = "fc.auth.recovery-attempt";

type HintStorage = Pick<Storage, "removeItem">;

export function clearSessionRecovery(storage: HintStorage): void {
  storage.removeItem(SESSION_HINT);
  storage.removeItem(RECOVERY_ATTEMPT);
}
